import axiosInstance from '@/utils/api.js'

var state = {
  users: [],
  usersCount: [],
  usersList: [],
  fullInfoUsers: {},
  user: [],
  all_users: [],
  usersExtendedSearch: [],
  group_users: [],
  web_settings: [],
  policy: {}
}

var getters = {
  USERS: (state) => {
    return state.users
  },
  USERS_COUNT: (state) => {
    return state.usersCount
  },
  USERS_LIST: (state) => {
    return state.usersList
  },
  FULL_INFO_USERS: (state) => {
    return state.fullInfoUsers
  },
  USER: (state) => {
    return state.user
  },
  USER_NOTIFICATION_POLICY: (state) => {
    return state.policy
  },
  ALL_USERS: (state) => {
    return state.all_users
  },
  USERS_EXTENDED_SEARCH: (state) => {
    return state.users
  },
  GROUP_USERS: (state) => {
    return state.group_users
  },
  WEB_SETTINGS: (state) => {
    return state.web_settings
  }
}

var mutations = {
  SET_USERS: (state, payload) => {
    state.users = payload
  },
  SET_USERS_COUNT: (state, payload) => {
    state.usersCount = payload
  },
  SET_USERS_LIST: (state, payload) => {
    state.usersList = payload
  },
  SET_FULL_INFO_USERS: (state, payload) => {
    state.fullInfoUsers = payload
  },
  SET_USER: (state, payload) => {
    state.user = payload
  },
  SET_USER_NOTIFICATION_POLICY: (state, payload) => {
    state.policy = payload
  },
  SET_ALL_USERS: (state, payload) => {
    state.all_users = payload
  },
  SET_USERS_EXTENDED_SEARCH: (state, payload) => {
    state.users = payload
  },
  SET_GROUP_USERS: (state, payload) => {
    state.group_users = payload
  },
  SET_WEB_SETTINGS: (state, payload) => {
    state.web_settings = payload
  }
}

var actions = {
  GET_ALL_USERS: async (context, payload) => {
    let result = await axiosInstance.get('/users')
    if (result.status === 200) {
      context.commit('SET_ALL_USERS', result.data)
    }
  },
  GET_USER: async (context, payload) => {
    let result = await axiosInstance.get('/users?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_USER', result.data)
    }
  },
  GET_USER_NOTIFICATION_POLICY: async (context, payload) => {
    let result = await axiosInstance.get('/users/notification_messages_policy?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_USER_NOTIFICATION_POLICY', result.data)
    } else {
      context.commit('SET_USER_NOTIFICATION_POLICY', {})
    }
  },
  USERS_SEARCH: async (context, payload) => {
    let result = await axiosInstance.post('/users/short_search', payload)
    if (result.status === 200) {
      context.commit('SET_USERS', result.data)
    }
  },
  GET_FULL_INFO_USERS: async (context, payload) => {
    let result = await axiosInstance.get('/users/full_info?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_FULL_INFO_USERS', result.data)
    }
  },
  GET_USERS_COUNT: async (context, payload) => {
    let result = await axiosInstance.get('/users/users_count?is_card=' + payload)
    if (result.status === 200) {
      context.commit('SET_USERS_COUNT', result.data)
    }
  },
  GET_USERS_LIST: async (context, payload) => {
    let result = await axiosInstance.get('/users/users_list?is_card=' + payload.isCard + '&to=' + payload.to + '&from=' + payload.from)
    if (result.status === 200) {
      context.commit('SET_USERS_LIST', result.data)
    }
  },
  GET_USERS_EXTENDED_SEARCH: async (context, payload) => {
    let result = await axiosInstance.post('/users/extended_search', payload)
    if (result.status === 200) {
      context.commit('SET_USERS_EXTENDED_SEARCH', result.data)
    }
  },
  UPDATE_USER_LIFESTREAM_ID: (context, payload) => {
    return axiosInstance.put('/users/lifestream_id?user_id=' + payload.user_id + '&lifestream_id=' + payload.lifestream_id, {})
  },
  UPDATE_USERS: (context, payload) => {
    return axiosInstance.put('/users', payload)
  },
  UPDATE_USER_NOTIFICATION_POLICY: (context, payload) => {
    return axiosInstance.put('/users/notification_messages_policy', payload)
  },
  CREATE_USER_NOTIFICATION_POLICY: (context, payload) => {
    return axiosInstance.post('/users/notification_messages_policy?user_id=' + payload)
  },
  CANCEL_PAYMENT: (context, payload) => {
    return axiosInstance.put('/users/cancel_payment', payload)
  },
  CREATE_USERS: (context, payload) => {
    return axiosInstance.post('/users', payload)
  },
  DELETE_USERS: (context, payload) => {
    return axiosInstance.delete('/users?user_id=' + payload)
  },
  DELETE_USERS_BLOCK: (context, payload) => {
    return axiosInstance.delete('/users/blocks?block_id=' + payload)
  },
  GET_GROUP_USERS: async (context, payload) => {
    let result = await axiosInstance.get('/users/group_users?group_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_GROUP_USERS', result.data)
    }
  },
  GET_WEB_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/users/web_settings')
    if (result.status === 200) {
      context.commit('SET_WEB_SETTINGS', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/users.js